import comercialOnboardingPdf from '../../assets/docs/Manual-Comercial-Onboarding-Mari-Mosca.pdf';

export interface HelpDocument {
  id: string;
  title: string;
  description: string;
  keywords: string[];
  icon: string;
  pdfUrl: string;
}

export const HELP_DOCUMENTS: HelpDocument[] = [
  {
    id: 'comercial',
    title: 'Comercial',
    description: 'Manual do comercial e onboarding: funil, etapas, checkout e registro de alunas.',
    keywords: [
      'comercial',
      'onboarding',
      'manual',
      'lead',
      'leads',
      'funil',
      'pipeline',
      'checkout',
      'vendas',
      'desistência',
      'etapa',
      'aluna',
      'pagamento',
    ],
    icon: 'enterprise',
    pdfUrl: comercialOnboardingPdf,
  },
];

export const getHelpDocumentById = (id: string) => (
  HELP_DOCUMENTS.find((document) => document.id === id) ?? null
);

export const searchHelpDocuments = (query: string) => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return HELP_DOCUMENTS;
  }

  return HELP_DOCUMENTS.filter((document) => {
    const haystack = [
      document.title,
      document.description,
      ...document.keywords,
    ].join(' ').toLowerCase();

    return haystack.includes(normalizedQuery);
  });
};
